import styled from "styled-components";
import {
  ArrowDownFullIcon,
  ArrowUpFullIcon,
  CheckIcon,
  CloseCircleIcon,
  CopyIcon,
  DownloadIcon,
  FilterIcon,
  PlusCircleIcon,
  TrashIcon,
} from "@8x8/oxygen-icon/icons";
import {
  CSVIcon,
  GroupbyIcon,
  NewTabIcon,
  PrinterIcon,
} from "@8x8/oxygen-icon";
import ArrowDownIcon from "@8x8/oxygen-icon/icons/ArrowDownIcon";
import { COLORS } from "@/react/theme/constants";

export const StyledFilterIcon = styled(FilterIcon).attrs({
  size: 18,
})`
  color: ${COLORS.primary};
`;
export const StyledDownloadIcon = styled(DownloadIcon).attrs({
  size: 18,
})`
  margin-right: 16px;
  color: ${COLORS.primary};
  fill: currentColor;
`;

export const StyledPlusCircleIcon = styled(PlusCircleIcon).attrs({
  size: 18,
})`
  color: ${COLORS.primary};
  fill: currentColor;
  margin-right: 16px;
`;

export const StyledRedTrashIcon = styled(TrashIcon).attrs({
  size: 18,
})`
  margin-right: 16px;
  color: ${COLORS.danger};
  fill: currentColor;
`;

export const StyledArrowUpFullIcon = styled(ArrowUpFullIcon).attrs({
  size: 18,
})`
  color: ${COLORS.primary};
  fill: currentColor;
`;

export const StyledArrowDownFullIcon = styled(ArrowDownFullIcon).attrs({
  size: 18,
})`
  color: ${COLORS.primary};
  fill: currentColor;
`;

export const BlackCopyButton = styled(CopyIcon).attrs({
  size: 18,
})`
  color: ${COLORS.primary};
  fill: currentColor;
`;

export const WhiteCopyButton = styled(CopyIcon).attrs({
  size: 18,
})`
  color: ${COLORS.background};
  fill: currentColor;
`;

export const StyledCheckIcon = styled(CheckIcon).attrs({
  size: 20,
})`
  color: ${COLORS.success};
  fill: currentColor;
`;

export const StyledCloseCircleIcon = styled(CloseCircleIcon).attrs({
  size: 20,
})`
  color: ${COLORS.danger};
  fill: currentColor;
`;
export const StyledNewTabIcon = styled(NewTabIcon).attrs((props) => ({
  size: props.size || 24,
}))`
  color: ${COLORS.background};
  fill: currentColor;
`;
export const StyledPrinterIcon = styled(PrinterIcon).attrs((props) => ({
  size: props.size || 24,
}))`
  color: ${COLORS.background};
  fill: currentColor;
`;
export const StyledGroupbyIcon = styled(GroupbyIcon).attrs((props) => ({
  size: props.size || 24,
}))`
  color: ${COLORS.background};
  fill: currentColor;
`;

export const StyledCSVIcon = styled(CSVIcon).attrs((props) => ({
  size: props.size || 24,
}))`
  margin-right: 16px;
  fill: currentColor;
`;

export const StyledArrowDownIcon = styled(ArrowDownIcon).attrs((props) => ({
  size: props.size || 24,
}))`
  margin-left: 8px;
  fill: currentColor;
`;
